var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSplitScreenOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 11V3H7.5V11H8.5ZM6 0.5H3V1.5H6V0.5ZM0.5 3V6H1.5V3H0.5ZM0.5 6V15H1.5V6H0.5ZM3 17.5H6V16.5H3V17.5ZM7.5 11V15H8.5V11H7.5ZM3 0.5C1.61929 0.5 0.5 1.61929 0.5 3H1.5C1.5 2.17157 2.17157 1.5 3 1.5V0.5ZM8.5 3C8.5 1.61929 7.38071 0.5 6 0.5V1.5C6.82843 1.5 7.5 2.17157 7.5 3H8.5ZM6 17.5C7.38071 17.5 8.5 16.3807 8.5 15H7.5C7.5 15.8284 6.82843 16.5 6 16.5V17.5ZM0.5 15C0.5 16.3807 1.61929 17.5 3 17.5V16.5C2.17157 16.5 1.5 15.8284 1.5 15H0.5Z",
    fill: "#9C9C9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 11V3H16.5V11H17.5ZM15 0.5H12V1.5H15V0.5ZM9.5 3V6H10.5V3H9.5ZM9.5 6V15H10.5V6H9.5ZM12 17.5H15V16.5H12V17.5ZM16.5 11V15H17.5V11H16.5ZM12 0.5C10.6193 0.5 9.5 1.61929 9.5 3H10.5C10.5 2.17157 11.1716 1.5 12 1.5V0.5ZM17.5 3C17.5 1.61929 16.3807 0.5 15 0.5V1.5C15.8284 1.5 16.5 2.17157 16.5 3H17.5ZM15 17.5C16.3807 17.5 17.5 16.3807 17.5 15H16.5C16.5 15.8284 15.8284 16.5 15 16.5V17.5ZM9.5 15C9.5 16.3807 10.6193 17.5 12 17.5V16.5C11.1716 16.5 10.5 15.8284 10.5 15H9.5Z",
    fill: "#9C9C9C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplitScreenOutline);
export default __webpack_public_path__ + "static/media/split-screen-outline.2cf262c01c4dd844df7a35bb961dc2ae.svg";
export { ForwardRef as ReactComponent };